import { Widget } from "@typeform/embed-react";
import api from "api/landlord/renters";
import { useAuthContext } from "providers/Auth";
import { View } from "../types";
import { FC } from "react";
import { getErrorMessage } from "utils/error";

import { QueryCache } from "@tanstack/react-query";
import { toast } from "react-toastify";

const queryCache = new QueryCache();

type Props = {
  setView: (view: View) => void;
  refresh: () => Promise<void | unknown>;
};

export const KYBView: FC<Props> = ({ setView, refresh }) => {
  const { auth } = useAuthContext();

  return (
    <div style={{ height: "calc(100dvh - 68px)" }} className="animate-appear">
      <Widget
        id="yyGLS4SJ"
        style={{ height: "100%" }}
        hidden={{
          partner_id: String(auth?.id)
        }}
        onSubmit={(e) =>
          api
            .submitTypeformId(e.responseId)
            .then(() => {
              queryCache.clear();
              refresh().finally(() => {
                setView(View.Default);
              });
            })
            .catch((e) => {
              toast.error(getErrorMessage(e));
              setView(View.Default);
            })
        }
      />
    </div>
  );
};
